export function uniqueBy<T, V extends string>(array: T[], fn: (arg: T) => V) {
  const unique: IDictionary<boolean> = {};
  return array.filter((x: T) => {
    const key = fn(x);
    if (key !== undefined) {
      if (!unique[key]) {
        unique[key] = true;
        return true;
      }
    }
    return false;
  });
}
